<template>
  <div class="b-content-header">
    <router-link :to="to" class="btn-back" tag="span"></router-link>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'b-content-header',
  props: {
    to: {
      type: Object,
      default: undefined
    }
  }
}
</script>

<style scoped>
.b-content-header {
  display: flex;
  align-items: center;
  margin-bottom: 42px;
  margin-top: 20px;
}

.btn-back {
  position: relative;
  width: 40px;
  height: 40px;
  margin-right: 22px;
  background: #ffffff;
  border: 1px solid rgba(227, 30, 36, 0.13);
  border-radius: 50%;
  box-sizing: border-box;
  box-shadow: 0 18px 20px rgba(0, 0, 0, 0.03);
  cursor: pointer;
  transition: all 0.1s ease-in;
}

.btn-back:hover {
  border: 1px solid rgba(227, 30, 36, 0.3);
  box-shadow: 0 18px 20px rgba(0, 0, 0, 0.05);
}

.btn-back:before {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  top: 15px;
  left: 18px;
  border-left: 2px solid #e31e24;
  border-bottom: 2px solid #e31e24;
  transform: rotate(45deg);
}
</style>
